import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
    type IsoAndUnixTimestamp,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import {
    providerIdZodSchema,
    type ProviderId,
} from "@@/shared/providers/provider-id";
import type { SectionGroupId } from "@@/shared/section-groups/section-group";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type { SectionGroupItem } from "../section-group-item";

type SectionGroupEditCommand = {
    readonly _id: string;
    readonly _type: "SECTION_GROUP_EDIT_COMMAND";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly providerId: ProviderId;
    readonly sectionGroupId: SectionGroupId;
    readonly items: SectionGroupItem[];
};

type FactoryParams = Except<
    SectionGroupEditCommand,
    "_id" | "_type" | "_createdAt"
>;
const sectionGroupFactoryEditCommand = (params: FactoryParams) => {
    const sectionGroupEditCommand: SectionGroupEditCommand = {
        ...params,
        _id: generateId({ prefix: "section_group_edit_command__" }),
        _type: "SECTION_GROUP_EDIT_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return sectionGroupEditCommand;
};

const sectionGroupEditCommandZodSchema: z.ZodSchema<SectionGroupEditCommand> =
    z.object({
        _id: idZodSchema,
        _type: z.literal("SECTION_GROUP_EDIT_COMMAND"),
        _createdAt: isoAndUnixZodSchema,
        providerId: providerIdZodSchema,
        sectionGroupId: idZodSchema,
        items: z.array(z.any()), // TODO! FIX THIS AND VALIDATE
    });

export { sectionGroupEditCommandZodSchema, sectionGroupFactoryEditCommand };
export type {
    FactoryParams as CreateSectionGroupEditCommandParams,
    SectionGroupEditCommand,
};
